import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {IEmpresa} from "@models/empresa/IEmpresa.ts";
import {TableCell, TableRow} from '@mui/material'
import {useEffect, useState} from 'react'
import {useEmpresa} from "@components/empresas/hooks/useEmpresa.ts";
import {EmpresaInfoNavButton} from "@components/empresas/info/EmpresaInfoNavButton.tsx";

interface EmpresaInfoRowProps extends Omit<DefaultInfoV1Props<IEmpresa>, 'variant'> {

}

export const EmpresaInfoRow = (props: EmpresaInfoRowProps) => {
    const {EndComponent} = props
    const {getEmpresa} = useEmpresa()

    const [value, setValue] = useState<IEmpresa>(props.value)

    useEffect(() => {
        if (props.value) {
            setValue(props.value)
        }
    }, [props.value]);

    useEffect(() => {
        if (value == null && props.expectedId) {
            getEmpresa({id: props.expectedId}).then(x => {
                    if (x.items != null) {
                        setValue(x.items)
                    }
                }
            )
        }
    }, [value]);

    if (value == null) return null;

    return (<TableRow>
        <TableCell><EmpresaInfoNavButton value={value}/></TableCell>
        <TableCell>{value.nroFilial}</TableCell>
        <TableCell>{value.nome}</TableCell>
        <TableCell>{value.cnpj}</TableCell>
        <TableCell align={'right'}>{EndComponent && <EndComponent {...value} />}</TableCell>
    </TableRow>)
}